module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-1-Video.20fc4d49.webp";